<template>
  <b-card style="padding:40px;">
    <h5><b>LIST OF DELIVERY ORDER</b></h5>
    <hr />
    <TableDeliveryOrderIndex
      :fields="fields.fields"
      :type="`main`"
      :filter="this.filter"
      :page="this.page"
      :name="this.name"
      :date="this.date"
    />
  </b-card>
</template>

<script>
import TableDeliveryOrderIndex from "@/table/admin/deliveryOrder/TableDeliveryOrderIndex";

export default {
  data() {
    return {
      items: [],
      fields: {
        fields: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      },

      filter: "",
      page: "",
      name: "",
      date: ""
    };
  },
  created() {
    if (this.$route.query.filter !== undefined) {
      this.filter = this.$route.query.filter;
      this.page = this.$route.query.page;
      this.name = this.$route.query.name;
      this.date = this.$route.query.date;
    }
  },
  methods: {},
  components: {
    TableDeliveryOrderIndex
  }
};
</script>
<style lang="css" scoped></style>
